import TokenType from './schema/TokenType';
import { computed, ObservableMap, IComputedValue } from 'mobx';

export interface BotIdDefinition {
    id: string;
    tokenType: TokenType;
}

export const ALERT_AI_BOT_ID: BotIdDefinition = {
    id: 'ja7lKjj2NnQ.cwA.Krg.hfkh3ftaMUOb57AnI3gEJw-TZrkxQd1glDepIPKj6yo',
    tokenType: TokenType.ConnectorsLTI,
};
export const DEMO_BOT_ID: BotIdDefinition = {
    id: 'hXP0lB4sF4E.ihaAU12Q9puBSDe5dMnr8RITJalvWkCqiQadGVOHmIc',
    tokenType: TokenType.AAD,
};

const ALL_BOTS = [ALERT_AI_BOT_ID, DEMO_BOT_ID];

export const bots: IComputedValue<ObservableMap<string, BotIdDefinition>> = computed(() => {
    const newMap = new ObservableMap<string, BotIdDefinition>();
    ALL_BOTS.forEach(bot => {
        newMap.set(bot.id, bot);
    });
    return newMap;
});
